import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverShiftFilterEntity } from '../../domain/entities/DriverShiftFilterEntity'

export class DriverShiftFilterModel extends DriverShiftFilterEntity {
  driverId?: number
  constructor(dataDto: DriverShiftFilterEntity) {
    super()
    mapEntityProperties<DriverShiftFilterModel>(this, dataDto, {
      exclude: ['driver'],
      map: {
        driverId: dataDto.driver?.id
      }
    })
  }
}
